export default (date) => date
  .substring(0, 10)
  .replace(/[^\d]/g, '')
  .replace(/^(\d{2})/, '$1/')
  .replace(/^(\d{2})\/(\d{2})/, '$1/$2/');
